import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import List from '../components/List'
import Login from '../components/Login'
import Troubleshooting from '../components/Troubleshooting'
import TroubleshootingLoc from '../components/TroubleshootingLoc'
import ActivityLog from '../components/ActivityLog'
import MappingTool from '../components/MappingTool'
import AcademySearch from '../components/AcademySearch'
import auth from '../services/auth'
import Academy from '../components/Academy'
import store from '../data/AppData'

Vue.use(VueRouter)

const reqAuth = { requiresAuth: true }

const routes = [
	{ path: '/', component: Home, meta: reqAuth },
	{ path: '/home', component: Home, meta: reqAuth },
	{ path: '/login', component: Login },
	{ path: '/list', component: List, meta: reqAuth },
	{ path: '/academy/:id', component: Academy, meta: reqAuth },
	{ name: 'mapping', path: '/mapping', component: MappingTool, meta: reqAuth },
	{ path: '/search', component: AcademySearch, meta: reqAuth },
	{ path: '/log', component: ActivityLog, meta: reqAuth },
	{ name: 'troubleshooting', path: '/troubleshooting', component: Troubleshooting, meta: reqAuth },
	{ name: 'troubleshootingloc', path: '/troubleshootingloc', component: TroubleshootingLoc, meta: reqAuth }
]

export const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	if (!auth.loginAttempted) {
		auth.refresh(next)
	} else {
		store.commit('clearDataError')
		next()
	}
})
// do auth redirect if needed
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth) && !store.state.user.authenticated) {
		next({ path: '/login' })
	} else {
		next()
	}
})



// WEBPACK FOOTER //
// ./src/routes/Router.js